import styled from 'styled-components'

/** SVG (currentColor) — hover e selecionado */
const SENTIMENT_SVG = {
  negative: '#FF4242',
  neutral: '#F8A04D',
  positive: '#1FBA5D',
} as const

const SENTIMENT_IDLE_SVG = '#98A2B3'

/** Título “motivos” e chips de razões */
export const REASONS_ACCENT = '#FFA947'

type SentimentVariant = keyof typeof SENTIMENT_SVG

function sentimentSvg(variant: SentimentVariant): string {
  return SENTIMENT_SVG[variant]
}

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 40px;
  width: 100%;
  min-width: min(496px, 90vw);
  max-width: 576px;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 600px) {
    padding: 24px 16px;
    min-width: 0;
    max-width: 100%;
  }
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`

export const Title = styled.h2`
  font-family: inherit;
  font-size: 2rem;
  font-weight: 600;
  line-height: 32px;
  color: var(--color-dark);
  margin: 0;
  flex: 1;
  min-width: 0;
`

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  flex-shrink: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: var(--color-dark);
  border-radius: var(--border-radius-default);
  transition:
    background 0.15s,
    color 0.15s;

  &:hover {
    background: var(--color-gray-10);
    color: var(--color-black);
  }
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`

export const Question = styled.p`
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 24px;
  color: var(--color-dark);
  margin: 0;
  text-align: center;
`

export const FacesRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
`

/** Humor (modal + prompt): mesma peça; `$selected` omitido/false no prompt. */
export const FaceButton = styled.button<{
  $variant: SentimentVariant
  $selected?: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  color: ${({ $selected, $variant }) =>
    $selected ? sentimentSvg($variant) : SENTIMENT_IDLE_SVG};
  transition:
    border-color 0.15s,
    color 0.15s;

  &:hover {
    color: ${({ $variant }) => sentimentSvg($variant)};
  }
`

export const SectionLabel = styled.p`
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 24px;
  color: var(--color-dark);
  margin: 0;
`

export const ChipsWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
`

export const Chip = styled.button<{ $selected: boolean }>`
  padding: 10px 16px;
  border-radius: 999px;
  font-size: 1.4rem;
  line-height: 20px;
  cursor: pointer;
  background: transparent;
  border: 1px solid
    ${({ $selected }) => ($selected ? '#FFA947' : 'var(--color-gray-30)')};
  color: ${({ $selected }) => ($selected ? '#FFA947' : '#344054')};
  transition:
    border-color 0.15s,
    color 0.15s;

  &:hover {
    border: 1px solid #ffa947;
    color: #ffa947;
  }
`

export const TextareaWrap = styled.div`
  width: 100%;

  textarea {
    width: 100%;
    box-sizing: border-box;
  }
`

export const SubmitButton = styled.button`
  width: 100%;
  height: 44px;
  border: none;
  border-radius: var(--border-radius-default);
  background: #ffa947;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  &:not(:disabled):hover {
    opacity: 0.92;
  }
`

/** Compact prompt in the consultation sidebar */
export const PromptWrap = styled.div`
  padding: 16px 20px 20px;
  border-bottom: 1px solid #f0f2f8;
`

export const PromptQuestion = styled.p`
  font-size: 1.4rem;
  line-height: 20px;
  color: var(--color-dark);
  margin: 0 0 12px;
  text-align: center;
`

export const PromptFaces = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`
